<template>
  <div class="vue-wrapper-full">
    <transition name="component-fade" mode="out-in">
      <component v-bind:is="selectedContentComponent" v-bind="theContentVars" v-on:switchKontraktView="onSwitchKontraktView"></component>
    </transition>
  </div>
</template>

<script>
import KundeKontraktShow from './KundeKontraktShow'
import KundeKontraktEdit from './KundeKontraktEdit'
import KundeKontraktInvoiceAr from './KundeKontraktInvoiceAr'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontrakt',
  props: {
    kunde: {
      type: Object,
      required: true
    },
    kontrakt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      selectedContentComponent: KundeKontraktShow,
      theContentVars: {
        kunde: this.kunde,
        kontrakt: this.kontrakt
      }
    }
  },
  created () {
    bus.$off('show-kontrakt-invoice-ar')
    bus.$off('hide-kontrakt-invoice-ar')
  },
  mounted () {
    if (this.$route.hash === '#edit') {
      this.selectedContentComponent = KundeKontraktEdit
    }

    // Go to ar invoice view
    bus.$on('show-kontrakt-invoice-ar', (data) => {
      this.$set(this.theContentVars, 'objektList', data)
      this.selectedContentComponent = KundeKontraktInvoiceAr
    })
    bus.$on('kunde-kontrakt-updated', (data) => {
      this.$set(this.theContentVars, 'kontrakt', data)
    })
    // Go back to normal view after ar invoice
    bus.$on('hide-kontrakt-invoice-ar', () => {
      this.$delete(this.theContentVars, 'objektList')
      this.onSwitchKontraktView(this.$route.hash === '#edit')
    })
  },
  methods: {
    onSwitchKontraktView (editMode) {
      if (editMode) {
        this.selectedContentComponent = KundeKontraktEdit

        this.$router.push({
          name: this.$route.name,
          params: this.$route.params,
          query: this.$route.query,
          hash: '#edit'
        })
      } else {
        this.selectedContentComponent = KundeKontraktShow

        this.$router.push({
          name: this.$route.name,
          params: this.$route.params,
          query: this.$route.query,
          hash: ''
        })
      }
    }
  }
}
</script>

<style scoped>
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
  }
  .component-fade-enter, .component-fade-leave-to
  /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontrakt.vue